import {
	BodyPosture,
	CargoHandlingCondition,
	PostureTwist,
	PostureLoadCenter,
	PostureArms,
	PostureHands,
	WorkConditionHandsPosition,
	WorkConditionTransfer,
	WorkConditionSpatialCondition,
	WorkConditionAdverse,
	WorkConditionClothes,
	WorkConditionHoldLoad,
	WorkOrganization
} from '@/components/views/Report/KimLhc/enums';

export type RiskLevel = 'LOW' | 'SLIGHTLY_INCREASED' | 'SUBSTANTIALLY_INCREASED' | 'HIGH';

export enum KimLhcCategoryKey {
	FREQUENCY = 'frequency',
	WEIGHT = 'weight',
	CARGO_HANDLING_CONDITION = 'cargoHandlingCondition',
	POSTURE = 'posture',
	WORK_CONDITION = 'workCondition',
	WORK_ORGANIZATION = 'workOrganization'
}

export interface KimLhcInformation {
	companyName: string;
	organizationName: string;
	sectorName: string;
	lineName: string;
	workstationName: string;
	activityName: string;
	evaluatorName: string;
	collectDate: string;
	dayDuration: number;
	activityDuration: number;
	transportingCargoInPairs: boolean;
	fileName: string;
	createdAt: string;
	fileId: string;
	workstationId: string;
}

export interface KimLhcRiskResult {
	manScore: number;
	manRiskLevel: RiskLevel;
	womanScore: number;
	womanRiskLevel: RiskLevel;
}

export interface FrequencyCategory {
	score: number;
	value: number;
	maxScore: number;
}

export interface WeightCategory {
	value: number;
	effectiveWeight: number;
	inclinedWeight: boolean;
	transportingCargoInPairs: boolean;
	maxScore: number;
	manScore: number;
	womanScore: number;
}

export interface CargoHandlingConditionCategory {
	score: number;
	value: CargoHandlingCondition;
	maxScore: number;
}

export interface PostureCategory {
	score: number;
	value: BodyPosture;
	additionalFactors: {
		twist: PostureTwist | null;
		loadCenter: PostureLoadCenter | null;
		arms: PostureArms | null;
		hands: PostureHands | null;
	};
	maxScore: number;
}

export interface WorkConditionCategory {
	score: number;
	handsPosition: WorkConditionHandsPosition | null;
	transfer: WorkConditionTransfer | null;
	spatialCondition: WorkConditionSpatialCondition | null;
	adverse: WorkConditionAdverse | null;
	clothes: WorkConditionClothes | null;
	holdLoad: WorkConditionHoldLoad | null;
	maxScore: number;
}

export interface WorkOrganizationCategory {
	score: number;
	value: WorkOrganization;
	maxScore: number;
}

export interface KimLhcCategories {
	frequency: FrequencyCategory;
	weight: WeightCategory;
	cargoHandlingCondition: CargoHandlingConditionCategory;
	posture: PostureCategory;
	workCondition: WorkConditionCategory;
	workOrganization: WorkOrganizationCategory;
}

export interface KimLhcResult {
	id: string;
	information: KimLhcInformation;
	result: KimLhcRiskResult;
	categories: KimLhcCategories;
	comment: string | null;
	consolidated: boolean;
}

export type KimLhcRiskLevel =
	| 'LOW'
	| 'SLIGHTLY_INCREASED'
	| 'SUBSTANTIALLY_INCREASED'
	| 'HIGH';

export interface KimLHCRiskCount {
	LOW: number;
	SLIGHTLY_INCREASED: number;
	SUBSTANTIALLY_INCREASED: number;
	HIGH: number;
}
